import { useAppDispatch } from "../../../app/hooks";
import { useNavigate } from "react-router-dom";
import { classroomSlice } from "../../../redux/classroom/classroomSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { hasPermission, PermissionId } from "../../../app/permissions";
import AddIcon from "@mui/icons-material/Add";
import PrizaAvatarGrid, { PrizaAvatarGridItem } from "../../../features/base/grid/PrizaAvatarGrid";
import { assertThumbnailUrl, LoadState } from "../../../redux/common";
import { retrieveSchoolRoutine, schoolRoutinesSlice, selectSchoolRoutines } from "../../../redux/school/schoolRoutinesSlice";
import { useEffect } from "react";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { routineSlice } from "../../../redux/routine/routineSlice";
import { routeRoutine, routeRoutineNew } from "../../../routes/routine";

interface ContentListProps {
    schoolId: string;
}

const RoutineList = ({ schoolId }: ContentListProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const user = useSelector(selectUser);
    const routines = useSelector(selectSchoolRoutines);

    useEffect(() => {
        if (routines.schoolId && routines.schoolId != schoolId) {
            dispatch(schoolRoutinesSlice.actions.clean());
        }
        if (routines.state.state == LoadState.NotStarted && isTokenReady(user))
            dispatch(retrieveSchoolRoutine({ schoolId }));
    }, [routines, schoolId, user]);


    const list = routines.list || [];

    const mapped: PrizaAvatarGridItem[] = list.map((item) => {
        return {
            image: assertThumbnailUrl(item.url),
            title: item.name,
            subtitle: "Rotina",
            click: () => {
                dispatch(routineSlice.actions.select(item));
                navigate(routeRoutine(schoolId, item.id));
            }
        };
    });

    const buttons = hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, schoolId) ? [
        {
            label: <AddIcon />,
            click: () => {
                dispatch(classroomSlice.actions.clean());
                navigate(routeRoutineNew(schoolId));
            }
        }
    ] : undefined;

    return <PrizaAvatarGrid list={mapped}
        toolbar={{
            label: "Rotinas",
            buttons: buttons
        }}
        state={routines.state}
        retry={() => { dispatch(schoolRoutinesSlice.actions.clean()); }}
        messages={{
            empty: "Nenhuma rotina associado a esta escola.",
            error: "Erro ao carregar rotinas."
        }}
    />;

};

export default RoutineList;